import { PropsWithChildren, useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useAddHtmlClass } from '@/shared/hooks/useAddHtmlClass.ts'

import '@/modules/game/app/i18n.ts'
import '@/modules/game/styles/index.css'
import { LoadingLayout } from '@/modules/game/app/layouts/LoadingLayout.tsx'
import { Toaster } from '@/modules/game/shared/ui/Toast.tsx'
import { useUpdateHTMLLangAttribute } from '@/modules/game/shared/lib/i18n/hooks/useUpdateHTMLLangAttribute.ts'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/app/i18n.ts'

export const GameLayout = ({ children }: PropsWithChildren) => {
  useAddHtmlClass('app-game')
  useUpdateHTMLLangAttribute()

  useEffect(() => {
    document.title = 'Lair │ Mini Dapp'
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <LoadingLayout>
        <div className={'flex flex-col items-center justify-center h-screen bg-[#6E61FF]'}>
          <div className={'flex flex-col max-w-[700px] size-full bg-[radial-gradient(50%_50%_at_50%_50%,#FFF_0%,#E2DFFF_100%)]'}>
            {children || <Outlet />}
          </div>
        </div>
      </LoadingLayout>
      <Toaster />
    </I18nextProvider>
  )
}
